module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"time":"Time","initiator":"Initiator","target":"Target","details":"Details"}}}')
  delete Component.options._Ctor
}
